<template>
<!-- :class="classObj" -->
  <div  class="app-wrapper">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>
    <sidebar v-if="!seeNavbarSidebar"    class="sidebar-container"/>
    <div class="main-container">
      <navbar v-if="!seeNavbarSidebar"/>
      <app-main/>
      <!-- <app-footer/> -->
    </div>   
    <Footer/> 
  </div>
</template>

<script>
import { Sidebar, Navbar, AppMain} from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { getSettings } from '@/api/index'
import Footer from './components/Footer.vue'
export default {
  name: 'Layout',
  components: {
    Sidebar,
    Navbar,
    AppMain,
    Footer    
  },
  mixins: [ResizeMixin],
  created() {
    getSettings().then(response => {
      window.SETTINGS = response.data.data
    })
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    seeNavbarSidebar(){
      let pathName=['LocationSlug','ReservationsSlug']
      // console.log(pathName.includes(this.$route.name));
      return pathName.includes(this.$route.name)     
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('closeSideBar', { withoutAnimation: false })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Layout.vue?d4a5e4b8